import React from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import OrgHomepageTemplatesPage from './OrgHomepageTemplates'
import OrgHomepageAssetsPage from './OrgHomepageAssets'
import UserHomepageTemplatesPage from './UserHomepageTemplates'
import CategoryLandingTemplatesPage from './CategoryLandingTemplates'

const HOMEPAGE_TEMPLATE_TABS = [
  { key: 'org', label: '조직 홈페이지', path: '/ops/templates/homepage/org', Component: OrgHomepageTemplatesPage },
  { key: 'org-assets', label: '조직홈페이지 이미지', path: '/ops/templates/homepage/org-assets', Component: OrgHomepageAssetsPage },
  { key: 'user', label: '개인홈페이지', path: '/ops/templates/homepage/user', Component: UserHomepageTemplatesPage },
  { key: 'category', label: '홍보용 페이지', path: '/ops/templates/homepage/category', Component: CategoryLandingTemplatesPage },
]

export default function HomepageTemplatesPage() {
  const { tab } = useParams()
  const activeTab = HOMEPAGE_TEMPLATE_TABS.find((item) => item.key === tab)

  if (!activeTab) {
    return <Navigate to="/ops/templates/homepage/org" replace />
  }

  const ActivePage = activeTab.Component

  return (
    <section className="space-y-4">
      <div className="border-b border-slate-200">
        <nav className="-mb-px flex flex-wrap gap-1" aria-label="홈페이지 템플릿 탭">
          {HOMEPAGE_TEMPLATE_TABS.map((item) => {
            const active = item.key === activeTab.key
            return (
              <Link
                key={item.key}
                to={item.path}
                aria-current={active ? 'page' : undefined}
                className={`inline-flex min-h-[2.75rem] items-center border-b-2 px-3 text-sm font-semibold transition-colors ${
                  active
                    ? 'border-brand-navy text-brand-navy'
                    : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800'
                }`}
              >
                {item.label}
              </Link>
            )
          })}
        </nav>
      </div>
      <ActivePage />
    </section>
  )
}
